
(function($){
	var FEM = {
		init: function() {
			$('.nav__hamburger, .nav__hamburger-close').on('click', function() {
				$('.nav__menu').toggleClass('nav__menu--open');
			});
		},

		addToList: function(listId, email, first_name, last_name, callback) {
			var data = {
				nonce: femdef.nonce,
				action: 'mailchimp',
				email: email,
				list_id: listId,
				first_name: first_name,
				last_name: last_name
			}
			$.ajax({
				type: 'post',
				data: data,
				url: femdef.ajaxUrl,
				success: function(res) {
					return callback(res);
				}
			});
		}
	}

	$(document).ready(function() {
		FEM.init();

		$('#sms-form').submit(function(e) {
			e.preventDefault();
			//$('.top__sms-form .button-spinner').css('display', 'flex');
			$('.top__sms-form .message').html('Skickar...');
			var data = $(this).serialize() + '&nonce=' + femdef.nonce + '&action=sms_gift';
			$.ajax({
				type: 'post',
				data: data,
				url: femdef.ajaxUrl,
				success: function(res) {
					//$('.top__sms-form .button-spinner').hide();
					$('.top__sms-form .message').html((res.success === true ? 'Tack för din gåva' : 'Det blev fel'));
				}
			});
		});

		$('.help__selector-button--black').click(function(e) {
			e.preventDefault();
			var amount = $(this).siblings('input:checked').val();
			var url = $(this).prop('href');
			if (amount) {
				url += '?amount=' + amount;
			}
			window.location = url;
		});

		$('.kvinna-widget__close').click(function() {
			$('.kvinna-widget').hide();
			Cookies.set('hide_widget', true, { expires: 1 });
		});

		if ($('.kvinna-widget').length) {
			var lastScroll = 0;
			var hasBeenDown = false;
			var isUp = $('.kvinna-widget').position().top === 0;
			$(window).scroll(function(e) {
				var widgetOffset = $('.kvinna-widget').offset().top;
				var scrollTop = $(window).scrollTop();
				var diff = scrollTop - lastScroll;
				lastScroll = scrollTop;
				if (scrollTop > 100) {
					hasBeenDown = true;
				}
				if (widgetOffset > 200 && diff > 5 && isUp === false) {
					$('.kvinna-widget').animate({
						top: '0'
					}, 'slow');
					isUp = true;
				}
				else if (widgetOffset < 200 && isUp === true && hasBeenDown === true && diff < 0) {
					$('.kvinna-widget').animate({
						top: '200px'
					}, 'slow');
					isUp = false
				}
			})
		}

		$('.mail_capture .mail_capture__submit').click(function() {
			$('.mail_capture .mail_capture__message').html('Vänta...');
			var email = $('.mail_capture .mail_capture__input').val();
			if (email) {
				FEM.addToList('f5565e99b7', email, null, null, function(res) {
					$('.mail_capture .mail_capture__input').val('');
					if (res) {
						$('.mail_capture .mail_capture__message').html(res.message);
					}
				});
			}
			else {
				$('.mail_capture .mail_capture__message').html('Du måste fylla i din epost');
			}
		});

		$('.footer__form .footer__submit').click(function(e) {
			e.preventDefault();
			$('.footer__form .footer__message').html('Vänta...');
			var email = $('.footer__form .footer__input').val();
			if (email) {
				FEM.addToList('f5565e99b7', email, null, null, function(res) {
					$('.footer__form .footer__input').val('');
					if (res) {
						$('.footer__form .footer__message').html(res.message);
					}
				});
			}
			else {
				$('.footer__form .footer__message').html('Du måste fylla i din epost');
			}
		});

		$('.mail_capture_alt .mail_capture_alt__submit').click(function() {
			$('.mail_capture_alt .mail_capture_alt__message').html('Vänta...');
			var email = $('.mail_capture_alt .mail_capture_alt__input').val();
			var listId = $('.mail_capture_alt .mail_capture_alt__select option:checked').val();
			if (email && listId) {
				FEM.addToList(listId, email, null, null, function(res) {
					$('.mail_capture_alt .mail_capture__input').val('');
					if (res) {
						$('.mail_capture_alt .mail_capture_alt__message').html(res.message);
					}
				});
			}
			else {
				$('.mail_capture_alt .mail_capture_alt__message').html('Du måste fylla i epost och stad.');
			}
		})


		if (window.location.search && window.location.search.match(/\?swish_order_id=\d+/)) {
			$('html, body').animate({
				scrollTop: $('#payment').offset().top
			});
		}


		$('.mailchimp_campaign__form form').submit(function(e) {
			e.preventDefault();
			var email = $(this).find('input[name="email"]').val();
			var list_id = $(this).find('input[name="list_id"]').val();
			var first_name = $(this).find('input[name="first_name"]').val();
			var last_name = $(this).find('input[name="last_name"]').val();
			var target = $(this).find('input[name="target"]').val();
			if (email && email !== '' && list_id && list_id !== '') {
				FEM.addToList(list_id, email, first_name, last_name, function(res) {
					$('.mailchimp_campaign .mailchimp_campaign__input').val('');
					if (res) {
						if (target && target !== '' && res.success) {
							$('.' + target).css('display', 'flex');
							$('html, body').animate({ scrollTop: $(document).height() }, "slow");
						}
						else {
							$('.mailchimp_campaign .mailchimp_campaign__message').html(res.message);
						}
					}
				});
			}
			else if (!email || email === '') {
				$('.mailchimp_campaign .mailchimp_campaign__message').html('Du måste fylla i epost.');
			}
			else {
				$('.mailchimp_campaign .mailchimp_campaign__message').html('Det blev fel.');
			}
		});


		$('.share_on_facebook').click(function() {
			FB.ui({
				method: 'share',
				href: window.location.href
			}, function(response){});
		});





	});

})(jQuery);
